var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrpSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 312,
    viewBox: "0 0 132.29 82.55",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -214.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.73 85.623)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-115.2 -48.508)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4918 0 0 2.4918 24.41 200.08)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12 12.75c1.63 0 3.07 0.39 4.24 0.9 1.08 0.48 1.76 1.56 1.76 2.73v1.62h-12v-1.61c0-1.18 0.68-2.26 1.76-2.73 1.17-0.52 2.61-0.91 4.24-0.91z",
    fill: "#5d6ad8"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3443be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 13c1.1 0 2-0.9 2-2s-0.9-2-2-2-2 0.9-2 2 0.9 2 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.13 14.1c-0.37-0.06-0.74-0.1-1.13-0.1-0.99 0-1.93 0.21-2.78 0.58-0.74 0.32-1.22 1.04-1.22 1.85v1.57h4.5v-1.61c0-0.83 0.23-1.61 0.63-2.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 13c1.1 0 2-0.9 2-2s-0.9-2-2-2-2 0.9-2 2 0.9 2 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 16.43c0-0.81-0.48-1.53-1.22-1.85-0.85-0.37-1.79-0.58-2.78-0.58-0.39 0-0.76 0.04-1.13 0.1 0.4 0.68 0.63 1.46 0.63 2.29v1.61h4.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m12 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z",
    fill: "#5d6ad8"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185.77 7.3161)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.0335 0 0 2.0335 273.19 192.77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 2h-8c-1.1 0-1.99 0.9-1.99 2l-0.01 16c0 1.1 0.89 2 1.99 2h12.01c1.1 0 2-0.9 2-2v-12zm2 16h-8v-2h8zm0-4h-8v-2h8zm-3-5v-5.5l5.5 5.5z",
    fill: "#5d6ad8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.078 0 0 1.078 299.9 172.94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.35 10.04c-0.68-3.45-3.71-6.04-7.35-6.04-2.89 0-5.4 1.64-6.65 4.04-3.01 0.32-5.35 2.87-5.35 5.96 0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zm-5.35 2.96v4h-4v-4h-3l5-5 5 5z",
    fill: "#868fe2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrpSub);
export default __webpack_public_path__ + "static/media/grp-sub.76efbd55a4caaea86d683dba354339b5.svg";
export { ForwardRef as ReactComponent };